export default "__VITE_ASSET__Djgh9rIy__"